import { ReactElement } from 'react';

interface ConditionalWrapperProps {
  condition: boolean;
  wrapper: (children: ReactElement) => ReactElement;
  children: ReactElement;
}

/**
 * Helper component to conditionally wrap React elements in another React element.
 */
export default function ConditionalWrapper({ condition, wrapper: wrap, children }: ConditionalWrapperProps) {
  return condition ? wrap(children) : children;
}
